import React from "react";
import NotificationsOutlinedIcon from "@material-ui/icons/NotificationsOutlined";
import { Badge, ClickAwayListener, withStyles, Paper, IconButton } from '@material-ui/core';
import Tooltip from "../../../common/StyledToolTip";
import { compose } from "recompose";
import withWidth from "@material-ui/core/withWidth";

const styles = (theme) => ({
  iconStyles: {
    height: "32px",
    boxSizing: "border-box",
    cursor: "pointer",
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
  },
  muiIconContainer: {
    borderLeft: `1px solid ${theme.headerBorderColor}`,
  },
  unreadCountBadge: {
    height: 15,
    minWidth: 15,
    backgroundColor: theme.error,
    color: theme.white
  },
  container: {
    position: "absolute",
    top: 30,
    width: 338,
    minHeight: 100,
    maxHeight: 200,
    overflowY: "auto",
    right: 8,
    boxShadow: `0px 4px 4px ${theme.shadowColor}`,
    backgroundColor: theme.ModalBGColor,
    color: theme.notificationColor,
    display: "flex",
    alignItems: "center",
  },
  desktopContainer: {
    top: 43,
  },
  tabContainer: {
    top: 45,
    right: -28,
  },
  notificationWrapper: {
    position: "relative",
  },
  emptyMsgContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
  emptyMsgIcon: { fontSize: "45px", marginBottom: "10px" },
  alertNotification: {
    height: "auto",
  },
  muiIconButtonStyle: {
    padding: "9px 15px",
  },
});

const Notifications = ({
  classes,
  width,
  showNotificationPanel,
  toggleNotificationPanel,
  unreadCount,
  showNewNotification,
  children,
}) => {
  return (
    <>
      <div className={`${classes.muiIconContainer} ${classes.iconStyles}`}>
        <IconButton
          color="inherit"
          className={classes.muiIconButtonStyle}
          onClick={toggleNotificationPanel}
          data-automationid="notification-icon"
        >
          <Tooltip title="Notifications">
            <Badge
              badgeContent={unreadCount}
              classes={{ badge: classes.unreadCountBadge }}
              color="primary"
            >
              <NotificationsOutlinedIcon />
            </Badge>
          </Tooltip>
        </IconButton>
      </div>
      {showNotificationPanel ? (
        <ClickAwayListener onClickAway={toggleNotificationPanel}>
          <div className={classes.notificationWrapper}>
            <Paper
              className={`${classes.container} ${
                ["xl", "lg"].includes(width)
                  ? classes.desktopContainer
                  : classes.tabContainer
              } customScroll`}
            >
              {showNewNotification ? (
                children
              ) : (
                <div className={classes.emptyMsgContainer}>
                  <NotificationsOutlinedIcon className={classes.emptyMsgIcon} />
                  <div>No Notifications</div>
                </div>
              )}
            </Paper>
          </div>
        </ClickAwayListener>
      ) : null}
    </>
  );
};

export default compose(withWidth(), withStyles(styles))(Notifications);
